import chalk from 'chalk';
import ora from 'ora';
import { getApiKey, getHost } from '../lib/config.js';
import { exchangeApiKey } from '../lib/api-client.js';
import { success, error, info } from '../lib/output.js';
import { isJsonMode, jsonOutput } from '../lib/globals.js';

export async function whoamiCommand(): Promise<void> {
  const json = isJsonMode();
  const apiKey = getApiKey();

  if (!apiKey) {
    if (json) {
      jsonOutput({ ok: false, error: 'AGT_API_KEY is not set' });
    } else {
      error('AGT_API_KEY is not set. Export it with your host API key (tlk_...)');
    }
    process.exitCode = 1;
    return;
  }

  const spinner = ora({ text: 'Exchanging API key\u2026', isSilent: json });
  spinner.start();

  try {
    const exchange = await exchangeApiKey(apiKey);
    spinner.stop();

    const framework = exchange.framework ?? 'unset';
    const claudeAuthLabel = exchange.claudeAuthMode === 'api_key'
      ? `api_key (fp: ${exchange.anthropicApiKeyFingerprint ?? 'unknown'})`
      : 'subscription';

    if (json) {
      jsonOutput({
        ok: true,
        api_key_prefix: apiKey.slice(0, 8) + '****',
        host: getHost(),
        host_id: exchange.hostId,
        team: exchange.teamSlug,
        team_id: exchange.teamId,
        email: exchange.userEmail,
        framework: exchange.framework,
        claude_auth_mode: exchange.claudeAuthMode,
        anthropic_api_key_fingerprint: exchange.anthropicApiKeyFingerprint,
      });
      return;
    }

    success('Authenticated via API key');
    info(`API Key:    ${chalk.bold(apiKey.slice(0, 8) + '****')}`);
    info(`Host:       ${chalk.bold(getHost())}`);
    info(`Host ID:    ${exchange.hostId}`);
    info(`Team:       ${chalk.bold(exchange.teamSlug ?? exchange.teamId)}`);
    info(`User:       ${chalk.bold(exchange.userEmail ?? 'unknown')}`);
    info(`Framework:  ${chalk.bold(framework)}`);
    if (framework === 'claude-code') {
      info(`Claude Auth: ${chalk.bold(claudeAuthLabel)}`);
    }
  } catch (err) {
    spinner.fail('Failed to exchange API key.');
    if (json) {
      jsonOutput({ ok: false, error: (err as Error).message });
    } else {
      error((err as Error).message);
    }
    process.exitCode = 1;
  }
}
